module.exports = __webpack_public_path__ + "img/image_webinars08@2x.ad64e999.png";